import React, {useRef} from 'react';
import styled from 'styled-components';
// import { InputField } from '../general_components/forms/input_fields/inputFieldDelegate';
import { RemoveButton } from '../general_components/content_management/reusableItems/buttons';
import { useBoardStore } from './boardStore';

const SearchBoxContainer = styled.div`
    position:relative;
    display: flex;
    align-items: center;
`
const SearchBox = styled.input`
    margin-right:1rem;
    width:15rem;
    max-height:2rem;
    border:var(--lighter-gray) solid thin;
    border-radius:0.8rem;
    outline: none;
    padding: 0.25rem 1.5rem 0.25rem 0.75rem;
    color:var(--gray);
    background:var(--bg);
    font-family:var(--main-font-family);
    font-weight:600;
    ::placeholder {
        color: var(--lighter-gray);
        font-weight:500;
        opacity: 1; /* Firefox */
    }
`
const ClearButton = styled.div`
    position:absolute;
    right:1.4rem;
    top:0.75rem;
`

export const MainBoardSearchBox = () => {
    const setFilterText = useBoardStore(s => s.setFilterText);
    const searchBox = useRef(null);
    
    return <SearchBoxContainer>
        <SearchBox 
            placeholder="Filtering..."
            onChange={(e) => {
                const searchText = e ? e.target.value.toLowerCase().trim() : "";
                setFilterText(searchText);
            }}
            ref={searchBox}
        />
        <ClearButton><RemoveButton customColor={"var(--light-gray)"} action={()=>{
            searchBox.current.value = "";
            setFilterText("");
        }} /></ClearButton>
    </SearchBoxContainer> 
    // const trucksByNumber = useBoardStore(s => s.trucksByNumber) || {};
    // const loadsById = useBoardStore(s => s.loadsById) || {};
    // const searchBox = useRef(null);
    
    // const highlightTruck = (target, highlight) =>{
    //     if(highlight){
    //         if(!target.className){
    //             target.className = "HIGHLIGHTED";
    //         }else if(!target.className.includes("HIGHLIGHTED")){
    //             target.className += " HIGHLIGHTED";
    //         }
    //     }else{
    //         if(target.className && target.className.includes("HIGHLIGHTED")){
    //             target.className = target.className.replace(" HIGHLIGHTED", "");
    //         } 
    //     }
    // }
    // const onChangeAction = (e) => {

    //     let searchText = e ? e.target.value.toLowerCase().trim() : "";
    //     for(const truckNumber of Object.keys(trucksByNumber)){
    //         const truckEntity = trucksByNumber[truckNumber];
    //         const currentLoad = truckEntity?.currentLoadId ? loadsById[truckEntity.currentLoadId] : null;
    //         const truckData = {
    //             driver1: truckEntity?.driver1,
    //             driver2: truckEntity?.driver2,
    //             currentTrailerNumber: truckEntity?.currentTrailer ? truckEntity.currentTrailer.trailerNumber : null,
    //             currentLoad: currentLoad ? {
    //                 loadNumber: currentLoad.loadNumber,
    //                 broker: currentLoad.broker?.brokerageName
    //             } : null
    //         };
            
    //         const truckCard = document.querySelector(`[data-trucknum="${truckNumber}"]`)
    //         if(truckCard){
    //             if(searchText === ""){
    //                 highlightTruck(truckCard, false);
    //             }else if(matchesTruckData(truckNumber, truckData, searchText)){
    //                 highlightTruck(truckCard, true);
    //             }else{
    //                 highlightTruck(truckCard, false);
    //             }
    //         }
            
    //     }
    // }
    // return <SearchBoxContainer>
    //     <SearchBox 
    //         placeholder="Highlight..."
    //         onChange={onChangeAction}
    //         ref={searchBox}
    //     />
    //     <ClearButton><RemoveButton customColor={"var(--light-gray)"} action={()=>{
    //         searchBox.current.value = "";
    //         onChangeAction(null);
    //     }} /></ClearButton>
    //     {/* <InputField $position={"position: absolute"} >
    //         <input style={{width:"10rem", right:"0", top:"-3.8rem", padding:"0.5rem 1rem ", fontSize:"0.9rem"}} type="text" />
    //     </InputField> */}
    // </SearchBoxContainer> 
}

